import { useUserStore } from '@/stores'

declare const window: Window & { dataLayer?: any[] }

export function pushAxonEvent(eventName: string, params: Record<string, any>, options: Record<string, any> = {}) {
  window.dataLayer = window.dataLayer || []

  if (params.items !== undefined)
    window.dataLayer.push({ items: null })
  window.dataLayer.push({ event: eventName, ...params, ...options })
}

interface AxonItemInput {
  item_id: string | number
  item_name?: string
  price?: string | number
  image_url?: string
  item_variant_id?: string
  quantity?: number
}

export function buildAxonItem(input: AxonItemInput) {
  const item: Record<string, any> = {
    item_id: String(input.item_id),
    quantity: input.quantity ?? 1,
  }
  if (input.item_name !== undefined)
    item.item_name = input.item_name
  if (input.price !== undefined)
    item.price = Number(input.price)
  if (input.image_url !== undefined)
    item.image_url = input.image_url
  if (input.item_variant_id !== undefined)
    item.item_variant_id = input.item_variant_id
  return item
}

/**
 * Axon 用户数据。push 到 dataLayer 的 user_data: { user_id } 嵌套结构，
 * 与游戏端及埋点文档保持一致；GTM 通过数据层变量路径 user_data.user_id 读取。
 * memberId 未就绪时返回 undefined（该字段不会进入上报）。
 */
export function getAxonUserData(): { user_id: string } | undefined {
  const userStore = useUserStore()
  let memberId: string | number = userStore.$state.memberId
  // store 尚未就绪时（如整页跳转后的新页面）回退读取 sessionStorage 缓存的用户信息
  if (!memberId) {
    try {
      memberId = JSON.parse(sessionStorage.getItem('member-info') || '{}').memberId || ''
    }
    catch {}
  }
  return memberId ? { user_id: String(memberId) } : undefined
}
